import React, { Component } from 'react';
import ReactModal from 'react-modal';
import { createModal } from 'react-modal-promise';

import { prettyKey } from 'helpers/formatters';

class PurchaseLineItemLeaseModal extends Component {
  constructor(props) {
    super(props);

    this.handleInputChange = this.handleInputChange.bind(this);
    this.updateOffloadAmount = this.updateOffloadAmount.bind(this);

    this.state = {
      offload_amount: '',
      error: '',
    };
  }

  handleInputChange({ target: { name, value } }) {
    if (this.state.error) this.setState({ error: '' });

    this.setState({ [name]: value });
  }

  updateOffloadAmount() {
    const { close } = this.props;
    const { offload_amount } = this.state;

    if ((!offload_amount || !Number(offload_amount)) && isNaN(offload_amount)) {
      this.setState({
        error:
          'Please, enter right number of offload amount or cancel this dialogue window',
      });
      return;
    }

    close(offload_amount);
  }

  render() {
    const { open, close, lease } = this.props;
    const { error } = this.state;

    return (
      <ReactModal
        appElement={document.getElementById('root')}
        isOpen={open}
        contentLabel="Minimal Modal Example"
        portalClassName="AdjustmentCreditPortal"
        overlayClassName="AdjustmentCreditModal__Overlay"
        className="AdjustmentCreditModal__Content"
      >
        <div className="modal-header">
          <span className="close">&times;</span>
          <h2>Change offload amount:</h2>
          <table className="table table-striped">
            <thead>
              <tr>
                <th>ID</th>
                <th>Total</th>
                <th>Owing</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{lease.id}</td>
                <td>{lease.total}</td>
                <td>{lease.owing}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="modal-body">
          <label className="control-label">
            {prettyKey('New offload amount')}
          </label>
          <input
            type="number"
            min="0"
            step="1"
            name="offload_amount"
            className="form-control"
            onChange={this.handleInputChange}
          />
          {error && <div style={{ color: 'red' }}>{error}</div>}
          <br />
          <p>Are you sure you want to change offload amount?</p>
        </div>
        <div className="modal-footer">
          <button
            className={'btn btn-primary'}
            onClick={this.updateOffloadAmount}
          >
            Change offload amount
          </button>
          <button className={'btn'} onClick={() => close(false)}>
            Cancel
          </button>
        </div>
      </ReactModal>
    );
  }
}

export default createModal(PurchaseLineItemLeaseModal);
